import { render } from "./registrar.vue?vue&type=template&id=c697b87c"
import script from "./registrar.vue?vue&type=script&lang=js"
export * from "./registrar.vue?vue&type=script&lang=js"

import "./registrar.vue?vue&type=style&index=0&id=c697b87c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__